export default __webpack_public_path__ + "static/colombo-3b792a6eb4b9532a5b6535b408812769.jpg";